import { useEffect, useRef } from 'react';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';
import { useGoodsBasic } from '../../../queries/useGoodsBasic';
import { isNil } from 'shared/src/utils';

export const useLogDisplayBrandHome = () => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();
  const { data: goodsBasic } = useGoodsBasic();
  const hasLogged = useRef(false);

  useEffect(() => {
    if (hasLogged.current) return;
    if (isNil(goodsBasic)) return;
    if (isNil(goodsBasic.brand)) return;

    hasLogged.current = true;
    logGoodsAnalytics({
      name: 'DISPLAY_BRAND_HOME',
      analytics: {
        GOODS_SNO: goodsBasic.sno.toString(),
        BRAND_SNO: goodsBasic.brand.sno.toString(),
        BRAND_NAME: goodsBasic.brand.name,
        MARKET_NAME: goodsBasic.market.name,
        MARKET_SNO: goodsBasic.market.sno.toString(),
        MARKET_TYPE: goodsBasic.brand.brand_vertical_type.name,
      },
    });
  }, [goodsBasic, logGoodsAnalytics]);
};